import { useLayoutEffect, useState } from "react";
import debounce from "../../../utils/functions/debounce";

const SCROLL_STEP = 120;

const useScroll = (containerRef) => {
  const [couldScrollUp, setCouldScrollUp] = useState(false);
  const [couldScrollDown, setCouldScrollDown] = useState(false);

  const handleScroll = () => {
    if (containerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
      const hasOverflow = scrollTop > 0;

      setCouldScrollUp(hasOverflow);
      setCouldScrollDown(scrollHeight - scrollTop > clientHeight);
    }
  };

  const handleScrollDown = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        top: SCROLL_STEP,
        behavior: "smooth",
      });
    }
  };

  const handleScrollUp = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        top: -SCROLL_STEP,
        behavior: "smooth",
      });
    }
  };

  useLayoutEffect(() => {
    const container = containerRef.current;
    const handleResize = debounce(handleScroll, 300);
    if (container) {
      container.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleResize);
      // We delay the first scroll event to avoid miscalculations
      setTimeout(handleScroll, 1000);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleResize);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef]);

  return {
    couldScrollUp,
    couldScrollDown,
    handleScroll,
    handleScrollDown,
    handleScrollUp,
  };
};

export default useScroll;
